const events = {
	CATEGORY_CLICKED: 'Category Clicked',
	TRY_STREAMYARD_CLICKED: 'Try StreamYard Clicked',
	SHARE_CLICKED: 'Share Clicked',
	CONTENT_CLICKED: 'Content Clicked',
	MAIN_CONTENT_INTERACTION_CLICKED: 'Main Content Interaction Clicked',
	BLOG_LOAD_MORE: 'Blog Load More',
	CASE_STUDIES_LOAD_MORE: 'Case Studies Load More',
};

export default events;
